import React, { useState, useEffect } from "react"
import { Dropdown, Icon, Image, Menu } from "semantic-ui-react"

import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import i18next from "i18next"

const TopMenu = (props) => {
  const [lang, setLang] = useState("")

  const changeLang = (lang, textLang) => {
    setLang(textLang)
    i18next.changeLanguage(lang, () => {})
    localStorage.setItem("lang", JSON.stringify([lang, textLang]))
  }

  const { t } = useTranslation()
  const { profile, logoImg, onSignOut, navigateHome, toggleSidebar } = props

  const showMenu = () => {
    document.querySelector(".right-menu").classList.toggle("active")
  }

  useEffect(() => {
    if (localStorage.getItem("lang")) {
      let data = JSON.parse(localStorage.getItem("lang"))
      setLang(data[1])
      i18next.changeLanguage(data[0])
    } else {
      setLang("Рус")
    }
    return () => {}
  }, [])

  return (
    <Menu borderless fixed="top" data-test="mainGrid">
      <div style={{ display: "flex" }}>
        <Menu.Item onClick={navigateHome}>{t("Marking")}</Menu.Item>
        <Menu.Item icon onClick={toggleSidebar}>
          <Icon name="content" link size="large" />
        </Menu.Item>
        <Menu.Item as={Dropdown} text={lang} pointing>
          <Dropdown.Menu>
            <Dropdown.Item
              content="Рус"
              value="ru"
              onClick={() => {
                changeLang("ru", "Рус")
              }}
            />
            <Dropdown.Item
              content="Eng"
              value="en"
              onClick={() => {
                changeLang("en", "Eng")
              }}
            />
          </Dropdown.Menu>
        </Menu.Item>
      </div>
      <Menu.Menu position="right">
        <Menu.Item>{profile.login}</Menu.Item>
        <Menu.Item>
          <Link to="/" onClick={onSignOut} style={{ color: "#b21e1e" }}>
            {t("logout")}
          </Link>
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  )
}

export default TopMenu
